import axiosApi, { setHeader } from "api/root.api";

export const reviseProject = async (body, token) => {
  const urlEnd = "/editor/project/v1/update";
  setHeader("Authorization", `Bearer ${token}`);
  const response = await axiosApi.post(urlEnd, body);
  const result = response.data;
  return result;
};
